import React, { useEffect, useState } from "react";
import {
  FormControl,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Stack,
  Pagination,
} from "@mui/material";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import image from "../../assets/thinking.jpg";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";
import { MdOutlineDescription } from "react-icons/md";

let navigate;

const flexContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
const formatDate = (apiDateString) => {
  const apiDate = new Date(apiDateString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  return apiDate.toLocaleString("en-US", options);
};

const SingleOpenExceptionitem = ({ data }) => {
  return (
    <>
      <StyledTableCell component="th" scope="row" align={"left"}>
        <Stack
          direction={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
        >
          <p style={{ padding: "0px", margin: "0px" }}>{data._id}</p>
          <Stack>
            {data.orderId && (
              <p style={{ padding: "0px", margin: "0px" }}>
                <span style={{ userSelect: "none" }}>OrderId. </span>
                {data.orderId}
              </p>
            )}
          </Stack>
        </Stack>
      </StyledTableCell>
      {/* <StyledTableCell align={"left"}>{data.category}</StyledTableCell>
      <StyledTableCell align={"left"}>{data.subcategory}</StyledTableCell> */}
      <StyledTableCell align="left">
        {data.ticketStatus === "Open" ? (
          <Chip
            style={{
              backgroundColor: "green",
              color: "white",
              fontWeight: "bold",
            }}
            label={data.ticketStatus}
          />
        ) : data.ticketStatus === "Waiting" ? (
          <Chip
            style={{
              backgroundColor: "orange",
              color: "white",
              fontWeight: "bold",
            }}
            label={data.ticketStatus}
          />
        ) : (
          <Chip
            style={{
              backgroundColor: "red",
              color: "white",
              fontWeight: "bold",
            }}
            label={data.ticketStatus}
          />
        )}
      </StyledTableCell>

      <StyledTableCell align={"left"}>
        {formatDate(data.createdAt)}
      </StyledTableCell>
      <StyledTableCell align={"left"}>
        {formatDate(data.updatedAt)}
      </StyledTableCell>
      <StyledTableCell
        align={"center"}
        onClick={() => navigate(`/support/${data._id}`)}
      >
        <MdOutlineDescription style={{ color: "#2A007C", fontSize: "30px" }} />
      </StyledTableCell>
    </>
  );
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f9f9fb",
    fontSize: "12px",
    border: "0px",
    fontWeight: "600",
    borderBottom: "1px solid #ddd",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    border: "0px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#white",
  },
  justifyContent: "flex-start",
  alignItems: "flex-start",
  "&:last-child td, &:last-child th": {
    border: "0px solid red",
  },
  borderBottom: "1px solid #ddd",
}));

const WaitingTickets = ({ status, flag }) => {
  // console.log(Token,status)
  navigate = useNavigate();
  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [selectedSortBy, setSelectedSortBy] = useState("");
  const [tickets, setTickets] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(
    searchParams.get("page") ? +searchParams.get("page") : 1
  );
  const [totalPage, setTotalPage] = useState(0);

  const handleDateRangeChange = (event) => {
    setSelectedDateRange(event.target.value);
  };

  const handleSortByChange = (event) => {
    setSelectedSortBy(event.target.value);
  };

  const handlePageChange = (e, value) => {
    setPage(value);
    setSearchParams({ page: value });
  };

  useEffect(() => {
    const params = {
      page: searchParams.get("page") || 1,
      limit: searchParams.get("limit") || 5,
      selectedDateRange,
      selectedSortBy,
    };

    axios
      .get(`${BASE_URL}/tickets/get-status/${user._id}/${status}`, {
        params,
      })
      .then((res) => {
        setTickets(res?.data?.tickets);
        setTotalPage(res?.data?.totalPages);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [flag, searchParams, selectedDateRange, selectedSortBy]);

  return (
    <Box>
      <div style={flexContainerStyle}>
        <FormControl>
          <select
            value={selectedDateRange}
            onChange={handleDateRangeChange}
            className="select-option"
          >
            <option value="">Select Date Range</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="last7days">Last 7 days</option>
            <option value="last10days">Last 10 days</option>
            <option value="last30days">Last 30 days</option>
          </select>
        </FormControl>

        <FormControl>
          <select
            value={selectedSortBy}
            onChange={handleSortByChange}
            className="select-option"
          >
            <option value="mostRecentCreated">
              Sort By - Most Recent Created
            </option>
            <option value="mostRecentUpdated">
              Sort By - Most Recent Updated
            </option>
          </select>
        </FormControl>
      </div>
      <Box mt={"20px"}>
        <TableContainer component={Paper} sx={{ marginBottom: "50px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Ticket ID
                </StyledTableCell>
                {/* <StyledTableCell style={{ fontWeight: "bold" }}>
                  Category
                </StyledTableCell>
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Sub-Category
                </StyledTableCell> */}
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Ticket Status
                </StyledTableCell>
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Resolution Due Date
                </StyledTableCell>
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Last Updated
                </StyledTableCell>
                <StyledTableCell style={{ fontWeight: "bold" }}>
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets?.length > 0 &&
                tickets.map((val, key) => {
                  return (
                    <StyledTableRow key={val._id}>
                      <SingleOpenExceptionitem data={val} />
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
          {tickets?.length > 0 && (
            <Stack padding={"10px"} justifyContent={"center"}>
              <Pagination
                sx={{ width: "fit-content", margin: "auto" }}
                color="primary"
                count={totalPage}
                page={page}
                onChange={handlePageChange}
              />
            </Stack>
          )}
        </TableContainer>
        {(!tickets || tickets.length === 0) && (
          <Box
            width={"100%"}
            bgcolor={"white"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            mt={"-25px"}
            textAlign={"center"}
            p={"10px"}
            borderRadius={"5px"}
          >
            <img width={"30%"} src={image} alt="ilustration" />
            <Typography>
              We could not find any data for the applied filters.
              <span style={{ display: "block" }}>
                Please change filters and retry.
              </span>
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default WaitingTickets;
